export default "__VITE_ASSET__2a19cc21__"